var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 20",
    width: 17,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 20,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAMAAABcfiZ7AAAAAXNSR0IB2cksfwAAAQJQTFRFAj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+EpNDAQAAAFZ0Uk5TAC2f3NKCEUL2/97q0RYL3/RIAgp7nEl/yfINYFGgGTeiCeDjB7qMKzpyGsaWfHQwHY+Qg06A+N1TA6fUYiEiNPNqeAgl2/7YM/25ZGezHp4vhJ07mI4SeiXzAAAAuUlEQVR4nF2N1Q7CUBBEF2dwirsXd5fi7vr/v0JLKL3hPOxkT7I7RB9Uao1WpycFgxEmMyzWn7DZHU7O5YbnZ7zwSeEPBGUTQliKCKKyiSEuzkQylZYNlwGfzWWQV7oKRYiUOKaenOVKlVlrIb7O841my/X90u7gS7cnif4Aw1FWEITxxDfFTDRzDBby+XK1jlF0ukkrH7e7PR1wZDtPaypBxZo8SI0za0agC1pXhhvojj/o8byzeF5vjXwbQusQti0AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberIcon);
export default __webpack_public_path__ + "static/media/memberIcon.5611276888ed0b155568ee8b5f0d5b80.svg";
export { ForwardRef as ReactComponent };